import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';

import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material';

import { FaFacebookF } from 'react-icons/fa';

import { Label } from '../Elements/Label.js';

import { signingUpUser, signUpUser } from '../../actions';

import {
  SIGN_UP,
  SIGN_UP_FORM_ROWS,
  SIGN_UP_TRACKING_NAME,
  SIGN_UP_WITH_GOOGLE,
  SIGN_UP_WITH_FACEBOOK,
} from '../../constants/Forms';

import { API_ENDPOINT } from '../../constants';

export const SignUpForm = ({ path }) => {
  const [termsAndConditionsChecked, setTermsAndConditionsChecked] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const dispatch = useDispatch();

  const { loading } = useSelector(({ userReducer: { loading } }) => ({
    loading,
  }));

  const handleGoogleSignUp = () => {
    mixpanel.track('Google Auth Sign Up', {
      path,
      destination_path: '/auth/google',
    });
    window.location.href = `${API_ENDPOINT}/auth/google`;
    // gtag_report_conversion(`${API_ENDPOINT}/auth/google`);
  };

  const handleFacebookSignUp = () => {
    mixpanel.track('Facebook Auth Sign Up', {
      path,
      destination_path: '/auth/facebook',
    });
    window.location.href = `${API_ENDPOINT}/auth/facebook`;
    // gtag_report_conversion(`${API_ENDPOINT}/auth/facebook`);
  };

  const handleOnUpKeyMixPanelTracking = (formField) => {
    mixpanel.track('Sign Up Form', {
      [formField]: getValues(formField) || formField,
      path,
    });
  };

  const onSubmit = async (data) => {
    mixpanel.track('Sign Up Form', {
      action: 'Submit',
    });
    dispatch(signingUpUser);
    dispatch(
      signUpUser({
        user: { ...data, firstname: data.firstName, lastname: data.lastName },
      }),
    );

    // setTimeout(() => {
    //   // gtag_report_conversion(`${window.location.pathname}`);
    // }, 4500);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {Object.keys(SIGN_UP_FORM_ROWS).map((row) => {
          const leftColumn = SIGN_UP_FORM_ROWS?.[row]?.[0];
          const rightColumn = SIGN_UP_FORM_ROWS?.[row]?.[1];
          return (
            <div className="sign-up-form-row" key={leftColumn.label}>
              <div
                className="sign-up-form-row-left"
                style={{ width: `${100 / SIGN_UP_FORM_ROWS?.[row]?.length}%` }}
              >
                <TextField
                  className={leftColumn?.className}
                  error={!!errors[leftColumn?.name]}
                  helperText={errors[leftColumn?.name]?.message}
                  id={leftColumn?.id}
                  placeholder={leftColumn?.label}
                  name={leftColumn?.name}
                  autoComplete="off"
                  {...register(leftColumn?.name, {
                    required: leftColumn?.required,
                    pattern: { ...leftColumn.pattern },
                  })}
                  variant="outlined"
                  sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
                  type={leftColumn?.type}
                  onKeyUp={(e) => {
                    if (SIGN_UP_TRACKING_NAME[e.target.name]) {
                      handleOnUpKeyMixPanelTracking(SIGN_UP_TRACKING_NAME[e.target.name]);
                    }
                  }}
                />{' '}
                <br />
              </div>
              {rightColumn && (
                <div className="sign-up-form-row-right">
                  <TextField
                    className={rightColumn?.className}
                    error={!!errors[rightColumn?.name]}
                    id={rightColumn?.id}
                    autoComplete="off"
                    helperText={errors[rightColumn?.name]?.message}
                    name={rightColumn?.name}
                    placeholder={rightColumn?.label}
                    variant="outlined"
                    sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
                    {...register(rightColumn?.name, {
                      required: rightColumn?.required,
                    })}
                    type={rightColumn?.type}
                    onKeyUp={(e) => {
                      if (SIGN_UP_TRACKING_NAME[e.target.name]) {
                        handleOnUpKeyMixPanelTracking(SIGN_UP_TRACKING_NAME[e.target.name]);
                      }
                    }}
                  />{' '}
                  <br />
                </div>
              )}
            </div>
          );
        })}
        <FormGroup>
          <FormControlLabel
            required
            control={
              <Checkbox
                checked={termsAndConditionsChecked}
                onChange={(e) => {
                  setTermsAndConditionsChecked(e.target.checked);
                  handleOnUpKeyMixPanelTracking('CheckBox ' + e.target.checked);
                }}
              />
            }
            label={<Label />}
          />
        </FormGroup>
        <div className="signup_button_wrapper">
          <Button
            type="submit"
            variant="outlined"
            sx={{
              '&:hover': { backgroundColor: 'black', color: 'white' },
              m: 0,
              color: 'white',
              textTransform: 'initial',
              backgroundColor: 'black',
              width: '100%',
              borderRadius: 2,
              mr: '3px',
              height: '48px',
              marginBottom: '20px',
              marginBottom: '5px',
              mt: '15px',
            }}
            disabled={loading}
          >
            {SIGN_UP}
          </Button>
        </div>
      </form>
      <Button
        variant="outlined"
        className="googleBtn"
        onClick={handleGoogleSignUp}
        startIcon={
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            width="18"
            height="18"
          />
        }
      >
        {SIGN_UP_WITH_GOOGLE}
      </Button>
      <Button
        variant="contained"
        className="facebookBtn"
        onClick={handleFacebookSignUp}
        startIcon={<FaFacebookF />}
      >
        {SIGN_UP_WITH_FACEBOOK}
      </Button>
    </>
  );
};
